/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from '../services/hub.service';

interface EventResponse {
  data: {
    data: any;
    [key: string]: any;
  };
}

interface EventParams {
  [key: string]: any;
}

export const eventsActions = {
  getEvents,
  getEventById,
  addEvent,
  updateEvent,
  deleteEvent,
  getRegistrants,
  getTags,
  addTag,
  deleteTag,
};

function unwrap(promise: any, context: string): any {
  if (promise && 'data' in promise) {
    return promise.data;
  }
  console.log(`error in actions ${context}`);
  return Promise.reject(`Error: ${context}`);
}

function getEvents(): Promise<any> {
  return services.get<EventResponse>(`/events/list?limit=200`).then((p) => unwrap(p, 'get events'));
}

function getEventById(id: string | number): Promise<any> {
  return services.get<EventResponse>(`/events/${id}`).then((p) => unwrap(p, 'get event by id'));
}

function addEvent(params: EventParams): Promise<any> {
  return services.post<EventResponse>(`/events/add`, params).then((p) => unwrap(p, 'add event'));
}

function updateEvent(id: string | number, params: EventParams): Promise<any> {
  return services
    .put<EventResponse>(`/events/update/${id}`, params)
    .then((p) => unwrap(p, 'update event'));
}

function deleteEvent(id: string | number): Promise<any> {
  return services
    .delete<EventResponse>(`/events/delete/${id}`)
    .then((p) => unwrap(p, 'delete event'));
}

function getRegistrants(id: string | number): Promise<any> {
  return services
    .get<EventResponse>(`/events/${id}/registrants?limit=500`)
    .then((p) => unwrap(p, 'get registrants'));
}

function getTags(): Promise<any> {
  return services.get<EventResponse>(`/events/tags/list`).then((p) => unwrap(p, 'get tags'));
}

function addTag(params: EventParams): Promise<any> {
  return services.post<EventResponse>(`/events/tags/add`, params).then((p) => unwrap(p, 'add tag'));
}

function deleteTag(id: string | number): Promise<any> {
  return services
    .delete<EventResponse>(`/events/tags/delete/${id}`)
    .then((p) => unwrap(p, 'delete tag'));
}
